export default {
  getHeader({ state, commit }, data) {
    commit("SET_HEADER_TITLE", data.access_token);
  },

  getnotificationMSg({ state, commit }, data) {
    commit("SET_NOTIFICATION_TOKEN", data.access_token);
  },
};
